import { useRef } from 'react';
export default function usePrevious(value) {
  var previous = useRef(undefined);
  var current = useRef(undefined);
  if (value !== current.current) {
    previous.current = current.current;
    current.current = value;
  }
  return previous.current;
}